import { useEffect, useState, useRef } from "react";

export default function Timer({ duration, onTimeUp, paused }) {
  const [timeLeft, setTimeLeft] = useState(duration);
  const intervalRef = useRef(null);

  useEffect(() => { setTimeLeft(duration); }, [duration]);

  useEffect(() => {
    if (paused) { clearInterval(intervalRef.current); return; }
    intervalRef.current = setInterval(() => {
      setTimeLeft((t) => {
        if (t <= 1) { clearInterval(intervalRef.current); onTimeUp(); return 0; }
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(intervalRef.current);
  }, [paused, onTimeUp]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pct = (timeLeft / duration) * 100;
  const urgent = timeLeft < 60;
  const warning = timeLeft < 300 && timeLeft >= 60;

  const ringColor = urgent ? "#dc2626" : warning ? "#d97706" : "#1a56db";

  return (
    <div className={`timer ${urgent ? "urgent" : warning ? "warning" : ""}`}>
      <svg className="timer-ring" viewBox="0 0 36 36" style={{ transform: "rotate(-90deg)" }}>
        <path className="timer-ring-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" strokeWidth="2.5" />
        <path
          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          fill="none" strokeWidth="2.5" strokeLinecap="round"
          stroke={ringColor}
          strokeDasharray={`${pct}, 100`}
          style={{ transition: "stroke-dasharray 1s linear" }}
        />
      </svg>
      <span className="timer-text" style={{ color: ringColor }}>
        {String(minutes).padStart(2, "0")}:{String(seconds).padStart(2, "0")}
      </span>
    </div>
  );
}
